/**
 * Format a date string to a localized display format.
 * Uses en-GB locale for DD MMM YYYY format to avoid day/month confusion.
 * @param dateString - ISO date string or any parseable date
 * @returns Formatted date string (e.g., "28 Dec 2025")
 */
export const formatDate = (dateString: string): string => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString; // Return original if invalid
  return date.toLocaleDateString("en-GB", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

/**
 * Format a date string for use in HTML date input fields.
 * @param dateString - ISO date string or any parseable date
 * @returns Date string in YYYY-MM-DD format
 */
export const formatDateForInput = (dateString?: string): string => {
  if (!dateString) return "";
  return new Date(dateString).toISOString().split("T")[0];
};

/**
 * Parse a JSON ingredients string into an array of ingredient objects.
 * @param ingredientStr - JSON string of ingredients
 * @returns Array of ingredient objects with id and name
 */
export const parseIngredients = (
  ingredientStr?: string
): { id: number; name: string }[] => {
  const DEFAULT = [{ id: 1, name: "" }];
  if (!ingredientStr) return DEFAULT;
  try {
    const parsed = JSON.parse(ingredientStr);
    if (Array.isArray(parsed) && parsed.length > 0) {
      return parsed.map((name: string, idx: number) => ({ id: idx, name }));
    }
  } catch {
    // Invalid JSON
  }
  return DEFAULT;
};
